// extracted by mini-css-extract-plugin
export var inputWrapper = "input-module--inputWrapper--2C1ns";
export var label = "input-module--label--2Iwfj";
export var input = "input-module--input--2RI82";
export var error = "input-module--error--3F-m5";
export var errorMessage = "input-module--errorMessage--2h08Q";
export var required = "input-module--required--3lT3i";